import * as React from "react";
const SvgFiRrStageConcert = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-stage-concert_svg__a)">
      <path
        fill="#062147"
        d="m21.193 3.832-7-3.344a4.98 4.98 0 0 0-4.31 0l-7 3.344A5.02 5.02 0 0 0 .039 8.34L0 22.997A1 1 0 0 0 .998 24H1a1 1 0 0 0 1-.997L2.008 20H22v3a1 1 0 1 0 2 0V8.344c0-1.956-1.076-3.686-2.807-4.512m-10.448-1.54a2.99 2.99 0 0 1 2.586 0L18.998 5H5.078zM13 18v-5l1.6-1.2a.999.999 0 1 0-1.2-1.6l-1.6 1.2c-.501.376-.8.975-.8 1.6v5H2.013l.025-9.655c0-.475.12-.932.327-1.344h2.634v1a1 1 0 1 0 2 0V7h4v1a1 1 0 1 0 2 0V7h4v1a1 1 0 1 0 2 0V7h2.692c.197.407.308.862.308 1.344V18zm5 5a1 1 0 0 1-1 1H7a1 1 0 1 1 0-2h10a1 1 0 0 1 1 1"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-stage-concert_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrStageConcert;
